skrilla.controller('mergeTournamentModalCtrl', function ($scope, cacheService, modalService, srefService, searchService) {
    var dismiss = function(){modalService.dismissAll();}

    $scope.tournament = cacheService.getObjectOrElse("tournament", dismiss);
    $scope.sport = cacheService.getObjectOrElse("contestSport", dismiss);

    $scope.onClick = function(id){
        modalService.confirm("Are you sure you'd like to merge these tournaments? This can't be reversed.", function(){
            searchService.put("tournaments/merge", {tournamentToKeep: id, tournamentToRemove: $scope.tournament.id}, "Tournaments successfully merged").then(function(response){
                srefService.go("tournamentDetails", {id: id, sport: $scope.sport})
                dismiss();
            })
        });
    }

});